import { createReducer, on, Action } from '@ngrx/store';

export interface AiData {
  scenes: Array<{
    description: string;
    objects?: Array<{
      description: string;
      position: string;
    }>;
    actions: Array<{
      object: string;
      description: string;
    }>;
  }>;
}
export interface AiState {
  loading: boolean;
  error?: string;
  prompt?: string;
  data?: {
    openai: AiData;
    claude: AiData;
  };
  showAIPanel: boolean;
  model: 'openai' | 'claude';
}

export const initialAiState: AiState = {
  loading: false,
  showAIPanel: false,
  model: 'claude',
  prompt: 'Flight ticket online purchase flow',
};

import {
  postClaudeStructured,
  postClaudeStructuredSuccess,
  postClaudeStructuredFailure,
  toggleAiPanel,
  setAiModel,
  setScenes,
  requestScenes,
  setLoading,
} from './ai.actions';

const _aiReducer = createReducer(
  initialAiState,
  on(postClaudeStructured, state => ({
    ...state,
    loading: true,
    error: undefined,
  })),
  on(postClaudeStructuredSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    data: response,
  })),
  on(postClaudeStructuredFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(toggleAiPanel, (state, { show }) => ({ ...state, showAIPanel: show })),
  on(setAiModel, (state, { model }) => ({ ...state, model })),
  on(setScenes, (state, { model, scenes }) => {
    console.log('set-scenes', { model, scenes });
    return {
      ...state,
      data: { ...state.data, [model]: { ...state.data?.[model], scenes } },
    };
  }),
  on(requestScenes, state => ({
    ...state,
    loading: true,
  })),
  on(setLoading, (state, { loading }) => {
    console.log('setLoading', loading);
    return { ...state, loading };
  }),
);

export function aiReducer(state: AiState | undefined, action: Action) {
  return _aiReducer(state, action);
}
